import { cva } from "class-variance-authority";
import { ActiveStatus as ActiveStatusT } from "global";

interface ActiveStatusProps {
  status: string;
}

const checkIsValidStatus = (target: string): target is ActiveStatusT => {
  return ["대기", "비운영", "운영중"].includes(target);
};

export default function ActiveStatus({ status }: ActiveStatusProps) {
  if (!checkIsValidStatus(status)) {
    return <span className="text-zinc-500">(알 수 없음)</span>;
  }

  return <span className={styles({ variant: status })}>{status}</span>;
}

const styles = cva("px-3 py-1 rounded-md border text-xs font-bold", {
  variants: {
    variant: {
      운영중: "bg-green-100 border-green-500 text-green-600",
      비운영: "bg-red-100 border-red-300 text-red-500",
      대기: "bg-amber-100 border-amber-500 text-amber-600",
    },
    defaultVariants: {
      variant: "대기",
    },
  },
});
